import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo-head";
import BookingThanks from "@/pages/BookingThanks";

export const Route = createFileRoute("/book/thanks")({
  component: BookingThanks,
  head: () =>
    pageHead({
      title: "Booking Confirmed | jaik",
      description: "Your strategy call with jaik is confirmed.",
      path: "/book/thanks",
      noindex: true,
    }),
});
